import React from 'react';
import { Flex, Box } from 'rebass';
import styled from 'styled-components';
import { left, width, position } from 'styled-system';
import btoa from 'btoa';
import Text from '../../../Text';
import {
  getDay,
  isBefore,
  differenceInCalendarDays,
  areRangesOverlapping,
} from 'date-fns';
import randomcolor from 'randomcolor';
import { Link } from 'gatsby';

export const getColorFromStr = (seed, s = 75, l = 75) => {
  const fallbackColor = '#fff';
  if (seed.length === 0) {
    return fallbackColor;
  }
  const hslArray = randomcolor({
    seed: btoa(seed),
    format: 'hslArray',
  });
  return `hsl(${hslArray[0]}, ${s}%, ${l}%)`;
};

const Wrapper = styled(Box)`
  position: absolute;
  padding-top: 32px;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const Inner = styled(Flex)`
  flex-direction: column;
  flex-wrap: wrap;
  position: relative;
  overflow: visible;
`;

const Event = styled(Box).attrs(() => ({
  p: 1,
}))`
  ${width}
  ${position}
  ${left}
  border-radius: 2px;
  white-space: nowrap;
  overflow: hidden;
  height: 24px;
  transition: .1s;
  &:hover {
    box-shadow: ${({ theme }) => `0 0 0 1px ${theme.colors.chestnutRose}`};
    z-index: 2;
  }
`;

const WeekEvents = ({ week, events }) => {
  return (
    <Wrapper>
      <Inner>
        {events.map((event, idx) => {
          const { start_date, end_date } = event;
          const startDate = new Date(start_date);
          const endDate = new Date(end_date);
          const sameDayEvents = events.filter(_event => {
            return areRangesOverlapping(
              startDate,
              endDate,
              new Date(_event.start_date),
              new Date(_event.end_date),
            );
          });
          const eventIdxInRange = sameDayEvents.findIndex(
            _event => _event.id === event.id,
          );
          const isFromPreviousWeek = isBefore(startDate, week[0]);
          const diff = Math.max(
            1,
            differenceInCalendarDays(endDate, startDate),
          );
          const dayUnit = 100 / 7;
          const props = {
            bg: getColorFromStr(
              event.country === 'United States' ? event.state : event.country,
              undefined,
              event?.event_name.includes('Anatomy & Physiology')
                ? 85
                : undefined,
            ),
            left: isFromPreviousWeek ? 0 : `${getDay(startDate) * dayUnit}%`,
            width: isFromPreviousWeek
              ? `${(getDay(endDate) + 1) * dayUnit}%`
              : `${(1 + diff) * dayUnit}%`,
            position: 'absolute',
            top: eventIdxInRange * 24,
          };
          return (
            <Link key={`${idx}-${event.id}`} to={`/event/${event.uid}`}>
              <Event title={event.event_name} {...props}>
                <Text fontSize={0}>{event.event_name}</Text>
              </Event>
            </Link>
          );
        })}
      </Inner>
    </Wrapper>
  );
};

export default WeekEvents;
